import { Component, input } from '@angular/core';
import { NgbPopover, NgbPopoverModule, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { PhoneType } from '../../enums/global.enums';

const TYPE_TO_ICON: Record<string, string> = {
  mobile: PhoneType.mobile,
  cell: PhoneType.mobile,
  home: PhoneType.home,
  landline: PhoneType.home,
  office: PhoneType.office,
  work: PhoneType.office,
  fax: PhoneType.fax
};

@Component({
  selector: 'phone-numbers-display',
  standalone: true,
  imports: [NgbPopover, NgbPopoverModule, NgbTooltip],
  templateUrl: './phone-numbers-display.component.html'
})
export class PhoneNumbersDisplayComponent {
  contacts = input<any[]>([]);
  phoneType = PhoneType as any;

  /** Resolve icon class from contact type (handles "Mobile", "Cell", "mobile", etc.) */
  getIconForContact(contact: any): string {
    const raw = (contact?.type ?? contact?.Type ?? '').toString().toLowerCase();
    return TYPE_TO_ICON[raw] ?? PhoneType.mobile;
  }

  /** Support both camelCase and PascalCase from API */
  getPhoneNumber(contact: any): string {
    return contact?.phoneNumber ?? contact?.PhoneNumber ?? '';
  }

  /** Contacts that have a non-empty phone number */
  get validContacts(): any[] {
    return (this.contacts() ?? []).filter(c => {
      const num = this.getPhoneNumber(c);
      return num != null && String(num).trim() !== '';
    });
  }
}
